module.exports = __webpack_public_path__ + "static/media/browser-safari.52c41fee.svg";